/** Page indices and ellipsis markers for shadcn-style numeric pagination. */
export function getDataTablePageNumbers(
  currentPageIndex: number,
  pageCount: number,
): Array<number | "ellipsis"> {
  if (pageCount <= 0) return [];
  if (pageCount <= 3) {
    return Array.from({ length: pageCount }, (_, index) => index);
  }

  const lastPageIndex = pageCount - 1;
  const current = Math.min(Math.max(currentPageIndex, 0), lastPageIndex);

  let windowStart: number;
  let windowEnd: number;

  if (current <= 2) {
    windowStart = 0;
    windowEnd = 2;
  } else {
    windowStart = current - 2;
    windowEnd = current;
    if (windowEnd > lastPageIndex) {
      windowEnd = lastPageIndex;
      windowStart = lastPageIndex - 2;
    }
  }

  const pages: Array<number | "ellipsis"> = [];
  const onLastPage = current === lastPageIndex;

  // … only when page 1 is not adjacent to the window (gap of 2+ hidden pages)
  if (!onLastPage && windowStart > 1) {
    pages.push("ellipsis");
  }

  for (let index = windowStart; index <= windowEnd; index += 1) {
    pages.push(index);
  }

  // Trailing … only while more pages exist after the window (never on the last page)
  if (!onLastPage && windowEnd < lastPageIndex) {
    pages.push("ellipsis");
  }

  return pages;
}
